import Vue from 'vue'
import Vuex from 'vuex'
import Router from 'vue-router'
import BootstrapVue from 'bootstrap-vue'
import datePicker from 'vue-bootstrap-datetimepicker';
import App from './App.vue'
import LoginPage from './components/LoginPage.vue'
import HomePage from './components/HomePage.vue'
import RoadPage from './components/RoadPage.vue'
import SettingPage from './components/SettingPage.vue'
import ParkingSpacePage from './components/ParkingSpacePage.vue'
import SearchPage from './components/SearchPage.vue'
import MessageInboxPage from './components/MessageInbox.vue'

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import vuetify from './plugins/vuetify';
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(require('vue-moment'));
Vue.use(BootstrapVue)
Vue.use(Router)
Vue.use(Vuex)
Vue.use(datePicker)
Vue.use(VueAxios, axios)

Vue.config.productionTip = false

const store = new Vuex.Store({
  state: {
    loaded: localStorage.getItem('user') && localStorage.getItem('authToken') ? true : false,
    user: JSON.parse(localStorage.getItem('user')),
    authToken: localStorage.getItem('authToken'),
    roadId: sessionStorage.getItem('roadId'),
    roadName: sessionStorage.getItem('roadName'),
    roadFilters: JSON.parse(sessionStorage.getItem('roadFilters')),

    psId: sessionStorage.getItem('psId'),
    psCode: sessionStorage.getItem('psCode'),
    siteName: localStorage.getItem('siteName'),
    roadList: JSON.parse(localStorage.getItem('roadList')),
  },
  mutations: {
    SetLoaded(state) {
      state.loaded = true;
    },
    RemoveLoaded(state) {
      state.loaded = false;
    },
    SetPS(state, data) {
      state.psId = data.id
      state.psCode = data.code
      sessionStorage.setItem('psId', data.id)
      sessionStorage.setItem('psCode', data.code)
    },
    SetRoad(state, road) {
      state.roadId = road.id
      state.roadName = road.name
      state.roadFilters = road.filters ?? []

      sessionStorage.setItem('roadId', road.id)
      sessionStorage.setItem('roadName', road.name)
      sessionStorage.setItem('roadFilters', JSON.stringify(road.filters ?? []))
    },
    SetUser(state, user) {
      state.user = user
      localStorage.setItem('user', JSON.stringify(user))
    },
    SetAuthToken(state, token) {
      state.authToken = token
      localStorage.setItem('authToken', token)
    },
    ClearAuth(state) {
      state.user = null
      state.authToken = null
      state.loaded = false
      localStorage.removeItem('user')
      localStorage.removeItem('authToken')
    },
    SetSiteName(state, siteName) {
      state.siteName = siteName;
      localStorage.setItem('siteName', siteName)
    },
    SetRoadList(state, roadList) {
      state.roadList = roadList;
      localStorage.setItem('roadList', JSON.stringify(roadList));
    }
  }
})

axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }

  return config
})

axios.interceptors.response.use((response) => {
  const token = response.headers['x-auth-token']

  if (token) {
    store.commit('SetAuthToken', token)
  }

  return response
})

const router = new Router({
  routes: [
    {
      path: '/login',
      name: 'login',
      components: {
        default: LoginPage,
      },
      meta: { requiresAuth: false },
    },
    {
      path: '/home',
      name: 'home',
      components: {
        default: HomePage,
      },
      meta: { requiresAuth: true },
    },
    {
      path: '/setting',
      name: 'setting',
      components: {
        default: SettingPage,
      },
      meta: { requiresAuth: true },
    },
    {
      path: '/road',
      name: 'road',
      components: {
        default: RoadPage,
      },
      meta: { requiresAuth: true },
    },
    {
      path: '/ps',
      name: 'ps',
      components: {
        default: ParkingSpacePage,
      },
      meta: { requiresAuth: true },
    },
    {
      path: "/search",
      name: "search",
      components: {
        default: SearchPage,
      },
      meta: { requiresAuth: true },
    },
    {
      path: "/messageInbox",
      name: "messageInbox",
      components: {
        default: MessageInboxPage,
      },
      meta: { requiresAuth: true },
    },
    {
      path: '*',
      redirect: '/home',
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => {
    return record.meta.requiresAuth;
  })) {
    axios.get('api/alive')
      .then(() => {
        next();
      })
      .catch((error) => {
        const status = error.response && error.response.status;

        if (status === 400 || status === 401 || status === 403) {
          store.commit('ClearAuth');
          next({ path: '/login' });
          return;
        }

        next();
      })
  } else {
    next();
  }
});

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
